import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComboCargoComponent} from './combo-cargo.component';
import {MaterialCommonModule} from 'src/app/material-modules/material-common.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {ComboPesquisavelModule} from '../combo-pesquisavel/combo-pesquisavel.module';


@NgModule({
    declarations: [ComboCargoComponent],
    imports: [
        CommonModule,
        MaterialCommonModule,
        MatExpansionModule,
        ComboPesquisavelModule
    ],
    exports: [ComboCargoComponent]
})
export class ComboCargoModule {
}
